"use strict";

function LangCtor() {

  // Adding a new language:
  //   1. Add it to `this.names`, The symbol name should match the folder name in res/locales/{name}
  //   2. Update file `ContinuousLocalization.yml`

  this.names = [
  { symbol: 'cs', label: 'Czech' },
  { symbol: 'da', label: 'Danish' },
  { symbol: 'de', label: 'German' },
  { symbol: 'en', label: 'English' },
  { symbol: 'en-GB', label: 'English (British)' },
  { symbol: 'es', label: 'Spanish' },
  { symbol: 'fi', label: 'Finnish' },
  { symbol: 'fr', label: 'French' },
  { symbol: 'fr-CA', label: 'French (Canadian)' },
  { symbol: 'hu', label: 'Hungarian' },
  { symbol: 'it', label: 'Italian' },
  { symbol: 'ja', label: 'Japanese' },
  { symbol: 'ko', label: 'Korean' },
  { symbol: 'nl', label: 'Dutch' },
  { symbol: 'no', label: 'Norwegian' },
  { symbol: 'pl', label: 'Polish' },
  { symbol: 'pt-BR', label: 'Portuguese (Brazil)' },
  { symbol: 'pt-PT', label: 'Portuguese (Portugal)' },
  { symbol: 'ru', label: 'Russian' },
  { symbol: 'sv', label: 'Swedish' },
  { symbol: 'tr', label: 'Turkish' },
  { symbol: 'zh-Hans', label: 'Chinese (Simplified)' },
  { symbol: 'zh-Hant', label: 'Chinese (Traditional)' },
  { symbol: 'zh-HK', label: 'Chinese (Hong Kong)' }];


  this.isSupported = function (isoCode) {
    for (var i = 0; i < this.names.length; ++i) {
      if (this.names[i].symbol === isoCode)
      return true;
    }
    return false;
  };

  this.getSupported = function (language) {

    // use iso scheme (ab/ab-XY/ab-Xyz)
    const tags = language.split('-');
    language = tags[0].toLowerCase();
    if (tags.length > 1) {
      let region = tags[1].toUpperCase();
      if (region.length > 2) {
        // E.g. 'zh-Hans'
        region = region[0] + region.substring(1).toLowerCase();
      }
      language += '-' + region;
    }

    // check supported language tags and subtags
    if (!this.isSupported(language)) {
      if (language.indexOf("zh-CN") > -1) language = "zh-Hans";else
      if (language.indexOf("zh-TW") > -1) language = "zh-Hant";else
      if (tags.length > 1 && this.isSupported(tags[0].toLowerCase())) language = tags[0];else
      language = "en";
    }

    return language;
  };

  this.getLanguages = function () {
    return this.names.slice();
  };

}

export const Lang = new LangCtor();